import type { ComponentType } from 'react';
import { Component as ReactComponent } from 'react';

export type IPushHistory<T> = T & {
    pushHistory: (state: T) => void;
};

export function historyEnabled<P extends IPushHistory<T>, T = P extends IPushHistory<infer U> ? U : unknown>(
    Component: ComponentType<P>
) {
    return class HistoryComponent extends ReactComponent<Omit<P, 'pushHistory'>, T> {
        private onPopStateRef: (event: PopStateEvent) => void;

        constructor(props: Omit<P, 'pushHistory'>) {
            super(props);
            this.state = window.history.state || {};
            this.onPopStateRef = (event: PopStateEvent) => {
                this.onPopState(event.state);
            };
            window.addEventListener('popstate', this.onPopStateRef);
        }

        public componentWillUnmount() {
            window.removeEventListener('popstate', this.onPopStateRef);
        }

        public render() {
            return (
                <Component
                    {...(this.props as P)}
                    {...this.state}
                    pushHistory={(state: T) => this.pushHistory(state)}
                />
            );
        }

        private onPopState(state: T) {
            let newState = this.getEmptyState();
            newState = { ...newState, ...(state || {}) };
            this.setState(newState);
        }

        private pushHistory(state: T) {
            window.history.pushState(state, '', '#search');
        }

        private getEmptyState(): T {
            const state: any = {};
            Object.keys(this.state).map((key) => {
                state[key] = undefined;
            });

            return state;
        }
    };
}
